





import Vue from 'vue'

export default Vue.extend({
  name: 'ComposeButton',

  props: {
    isPlaying: {
      type: Boolean,
      required: true,
    },
    isRecording: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    /**
     * 曲の作成を開始
     */
    composeMusic () {
      this.$emit('composeMusic')
    },
  },
})
